import React from "react";
import type { FC } from "react";

import cn from "classnames";

import { Icon } from "../../../Icon";

import type { IconProps } from "../../../Icon";
import type { IButtonInlineIcon } from "../../types";

import classes from "../../ButtonInline.styl";

const BUTTON_INLINE_ICON_TEST_ID = "button-inline-icon-test-id";

interface IButtonInlineIconMain extends IButtonInlineIcon {
    isRight?: boolean;
}

const ButtonInlineIcon: FC<IButtonInlineIconMain> = ({ isRight, ...props }) => {
    return (
        <Icon
            className={cn(classes["button-inline__icon"], {
                [classes["__right"]]: isRight,
            })}
            {...(props as IconProps)}
            data-tsid={BUTTON_INLINE_ICON_TEST_ID}
        />
    );
};

/* eslint-disable ok-custom-rules/check-attribute */
// Т.к. выше передаем data-tsid
export const LeftIcon: FC<IButtonInlineIcon> = (props) => {
    return <ButtonInlineIcon {...props} isRight={false} />;
};

LeftIcon.displayName = "ButtonInline.LeftIcon";

export const RightIcon: FC<IButtonInlineIcon> = (props) => {
    return <ButtonInlineIcon {...props} isRight />;
};

RightIcon.displayName = "ButtonInline.RightIcon";
